import React, { useEffect, useState, useRef } from 'react'
import { Modal } from 'react-bootstrap'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import StopIcon from '@material-ui/icons/Stop'

const TeacherFeedback = (props) => {
  const {
    feedbackVisible,
    Feedback,
    onPopupCancel,
    teacherRecording,
    isTeacherRecordPlaying,
    setIsTeacherRecordPlaying
  } = props

  const [displayModal, setDisplayModal] = useState(false)
  const currentRecordedTeacherAudioPlayer = useRef()
  const [currentRecordTime, setCurrentRecordTime] = useState(0)
  const [recordDuration, setRecordDuration] = useState(0)

  useEffect(() => {
    if (feedbackVisible) {
      setDisplayModal(true)
    } else {
      setDisplayModal(false)
    }
  }, [feedbackVisible])

  const handleClose = () => {
    if (currentRecordedTeacherAudioPlayer.current) {
      currentRecordedTeacherAudioPlayer.current.pause()
    }
    setDisplayModal(false)
    onPopupCancel()
  }

  function getTime(time) {
    if (!isNaN(time)) {
      return (
        Math.floor(time / 60) + ':' + ('0' + Math.floor(time % 60)).slice(-2)
      )
    }
  }
  //Teacher audio player
  useEffect(() => {
    if (currentRecordedTeacherAudioPlayer.current) {
      currentRecordedTeacherAudioPlayer.current.addEventListener(
        'ended',
        () => {
          setIsTeacherRecordPlaying(false)
          setCurrentRecordTime(0)
        }
      )
      return () => {
        currentRecordedTeacherAudioPlayer.current.removeEventListener(
          'ended',
          () => {
            setIsTeacherRecordPlaying(false)
            setCurrentRecordTime(0)
          }
        )
      }
    }
  }, [currentRecordedTeacherAudioPlayer.current])

  useEffect(() => {
    if (currentRecordedTeacherAudioPlayer.current) {
      currentRecordedTeacherAudioPlayer.current.addEventListener(
        'timeupdate',
        (e) => {
          setCurrentRecordTime(e.target.currentTime)
          setRecordDuration(e.target.duration)
        }
      )
    }
  }, [currentRecordedTeacherAudioPlayer.current])

  //teacher play audio
  function renderTeacherRecordPlay() {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <span>
          <p style={{ margin: 'auto', color: 'black' }}>
            {getTime(currentRecordTime) + ' / ' + getTime(recordDuration)}
          </p>
        </span>
        <span
          style={{
            width: '42px',
            height: '42px',
            borderRadius: '50%',
            backgroundColor: '#0093d1',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1,
            cursor: 'pointer',
            marginLeft: '2%'
          }}
          onClick={() => {
            if (teacherRecording) {
              if (!isTeacherRecordPlaying) {
                currentRecordedTeacherAudioPlayer.current = new Audio(
                  teacherRecording
                )
                const playPromise =
                  currentRecordedTeacherAudioPlayer.current.play()

                if (playPromise !== undefined) {
                  playPromise
                    .then((data) => {
                      console.log('audio played auto')
                    })
                    .catch((error) => {
                      console.log('playback prevented')
                    })
                }
                setIsTeacherRecordPlaying(true)
              } else {
                currentRecordedTeacherAudioPlayer.current.pause()
                setIsTeacherRecordPlaying(false)
                setTimeout(() => {
                  setCurrentRecordTime(0)
                }, 700)
              }
            }
          }}
        >
          {!isTeacherRecordPlaying ? (
            <PlayArrowIcon
              style={{
                width: '30px',
                height: '30px',
                color: 'white'
              }}
            />
          ) : (
            <StopIcon
              style={{
                width: '30px',
                height: '30px',
                color: 'white'
              }}
            />
          )}
        </span>
      </div>
    )
  }

  if (feedbackVisible) {
    return (
      <Modal show={displayModal} onHide={handleClose} centered={true}>
        <Modal.Header closeButton className='model_heading'>
          <Modal.Title className='model_title_name'>Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row model_heading_row'>
            <div className='col-lg-4'>
              <div className='form-group'>
                <p className='model_select_content'>Overall Rating</p>
              </div>
            </div>
            <div className='col-lg-8'>
              <div className='form-group'>
                {Feedback[0].Grade === '***** Outstanding!' ? (
                  <p className='model_select_content'>
                    &#x2B50;&#x2B50;&#x2B50;&#x2B50;&#x2B50;&nbsp;Outstanding!
                  </p>
                ) : Feedback[0].Grade === '**** Awesome job!' ? (
                  <p className='model_select_content'>
                    &#x2B50;&#x2B50;&#x2B50;&#x2B50;&nbsp;Awesome job!
                  </p>
                ) : Feedback[0].Grade === '*** Getting better!' ? (
                  <p className='model_select_content'>
                    &#x2B50;&#x2B50;&#x2B50;&nbsp;Getting better!
                  </p>
                ) : Feedback[0].Grade === '** Tighten up!' ? (
                  <p className='model_select_content'>
                    &#x2B50;&#x2B50;&nbsp;Tighten up!
                  </p>
                ) : (
                  <p className='model_select_content'>&#x2B50;&nbsp;Zoom in!</p>
                )}
              </div>
            </div>
          </div>
          <div className='row model_heading_row'>
            <div className='col-lg-4'>
              <div className='form-group'>
                <p className='model_select_content'>Feedback</p>
              </div>
            </div>
            <div className='col-lg-8'>
              <div className='form-group'>
                <p className='model_select_content'>{Feedback[0].Feedback}</p>
              </div>
            </div>
          </div>

          <div className='row model_heading_row'>
            <div className='col-lg-4'>
              <div className='form-group'>
                <p className='model_select_content'>Rework Count</p>
              </div>
            </div>
            <div className='col-lg-8'>
              <div className='form-group'>
                <p className='model_select_content'>
                  {Feedback[0].ReworkCount}
                </p>
              </div>
            </div>
          </div>
          {teacherRecording && (
            <div className='row model_heading_row'>
              <div className='col-lg-4'>
                <div className='form-group'>
                  <p className='model_select_content'>Recording</p>
                </div>
              </div>
              <div className='col-lg-8'>
                <div className='form-group'>{renderTeacherRecordPlay()}</div>
              </div>
            </div>
          )}
          <div
            className='form-group'
            style={{
              pointerEvents: 'none'
            }}
          >
            <textarea
              className='form-control-textarea'
              defaultValue={Feedback[0].Remarks}
              rows='4'
              id='comment'
              placeholder='Please show detailed steps.'
            />
          </div>
        </Modal.Body>
      </Modal>
    )
  }
  return null
}

export { TeacherFeedback }
